/* eslint camelcase: "off" */
import { privateFetcher } from 'services/appFetcher.services';
import ENDPOINTS from 'constants/endpoints.constants';
import APIError from 'exceptions/APIError';

export const getPudoLocationFetcher = async (
  orgId: number,
  shipmentPk: number,
): Promise<{ data: any }> => {
  try {
    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v2/ptp/shipment-collection-points/${orgId}/`;
    const { data } = await privateFetcher.get(url, {
      params: {
        shipment_pk: shipmentPk,
      },
    });
    return data;
  } catch (error) {
    if (error.response) {
      throw new APIError(error.response.data?.message, error);
    }
    throw error;
  }
};

export interface PudoLocationParams {
  postal_code: string;
  country_code: string;
  organization_slug: string;
  carrier_id?: string;
}

export const getPudoLocationsFetcher = async (
  orgId: number,
  params: PudoLocationParams,
): Promise<{ data: any[] }> => {
  try {
    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v2/ptp/collection-points/${orgId}/`;
    const { data } = await privateFetcher.get(url, { params });
    return data;
  } catch (error) {
    if (error.response) {
      throw new APIError('RETURN_TRY_DIFFERENT_POSTAL_CODE');
    }

    throw error;
  }
};
